import {useMutation} from "@tanstack/react-query";

import {updateRepresentativeMutationOptions} from "./update-representative.mutation-options";

export function useUpdateRepresentative(representativeId: string) {
  return useMutation(updateRepresentativeMutationOptions(representativeId));
}
